<i18n lang="yaml">
  ru:
    ActionSidebarDesignTitle: "Ориентация и дизайн"
  en:
    ActionSidebarDesignTitle: "Orientation and design"
</i18n>

<template>
  <PWAsideBodyItem
    :title="$t('ActionSidebarDesignTitle')"
  >
    <div :class="$style.actionSidebarDesign">
      <div>
        <PWSideToggle v-model="backgroundPositionLocal" />
      </div>
      <div :class="$style.actionSidebarDesignItems">
        <ActionSidebarDesignButton
          :src="logoFileBuffer.preview"
          :placeholder="getPlaceholder(logoFileBuffer.file, '140x56px, png, jpg')"
          @click="handleClick('logoFile')"
          @handleRemove="handleRemove('logoFile')"
        />
        <ActionSidebarDesignButton
          :src="backgroundImageBuffer.preview"
          :placeholder="getPlaceholder(backgroundImageBuffer.file, '380x620px, png, jpg')"
          @click="handleClick('backgroundImage')"
          @handleRemove="handleRemove('backgroundImage')"
        />
      </div>
    </div>

    <input
      v-show="false"
      ref="input"
      type="file"
      accept="image/jpeg, image/png, image/gif"
      @change="handleChange"
    >

    <PWCropper ref="cropper" />
  </PWAsideBodyItem>
</template>

<script>
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWSideToggle from '@/components/_ui/Pickers/PWSideToggle.vue'
import ActionSidebarDesignButton from '@/components/Actions/ActionSidebar/ActionSidebarDesign/ActionSidebarDesignButton.vue'
import PWCropper from '@/components/_ui/PWCropper.vue'
/**
 * Static
 */
import DefaultBackground from '@/assets/default-images/DefaultBackground.png'
import DefaultLogo from '@/assets/default-images/DefaultLogo.png'

export default {
  components: {
    PWAsideBodyItem,
    PWSideToggle,
    ActionSidebarDesignButton,
    PWCropper
  },
  props: {
    backgroundPosition: {
      type: String,
      default: 'left'
    },
    backgroundImage: {
      type: [
        Object,
        process.client ? window.File : Object
      ],
      default: null
    },
    logoFile: {
      type: [
        Object,
        process.client ? window.File : Object
      ],
      default: null
    }
  },
  data: () => ({
    savedKey: null,
    backgroundImageBuffer: {
      file: null,
      preview: null
    },
    logoFileBuffer: {
      file: null,
      preview: null
    }
  }),
  computed: {
    backgroundPositionLocal: {
      get () { return this.backgroundPosition },
      set (val) { this.$emit('update-backgroundPosition', val) }
    },
    backgroundImageLocal: {
      get () { return this.backgroundImage },
      set (val) { this.$emit('update-backgroundImage', val) }
    },
    logoFileLocal: {
      get () { return this.logoFile },
      set (val) { this.$emit('update-logoFile', val) }
    }
  },
  async mounted () {
    await this.initDefaultImages()
  },
  methods: {
    async initDefaultImages () {
      // import via fs
      const promises = [
        fetch(DefaultBackground),
        fetch(DefaultLogo)
      ]
      const results = await Promise.all(promises)
      // decode to blob
      const waitBlob = results.map(r => r.blob())
      const resultsBlob = await Promise.all(waitBlob)
      // save blob in buffer

      const downloadToBrowser = resultsBlob.map((blob, idx) => new File([blob],
        idx === 0 ? 'banner.png' : 'wazzup.png',
        { type: 'image/png' }
      ))
      const buffers = await Promise.all(downloadToBrowser)
      this.backgroundImageBuffer = {
        file: buffers[0],
        preview: URL.createObjectURL(buffers[0])
      }
      this.logoFileBuffer = {
        file: buffers[1],
        preview: URL.createObjectURL(buffers[1])
      }
      this.backgroundImageLocal = this.backgroundImageBuffer.file
      this.logoFileLocal = this.logoFileBuffer.file
    },

    getPlaceholder (file, placeholder) {
      if (!process.client) { return placeholder }
      return file instanceof File
        ? file.name
        : placeholder
    },

    handleClick (key) {
      this.$refs.input.click()
      this.savedKey = key
    },

    handleRemove (key) {
      this[`${key}Buffer`] = {
        file: null,
        preview: null
      }
      this[`${key}Local`] = null
    },

    checkFileSize (file) {
      return file.size > 5000000 // 5mb
    },

    async handleChange (ev) {
      const file = ev.target.files[0]
      const key = this.savedKey
      const aspectRatioEnum = {
        backgroundImage: 19 / 31,
        logoFile: 5 / 2
      }
      if (file && !this.checkFileSize(file)) {
        const croppedFile = await this.$refs.cropper.open({ file, aspectRatio: aspectRatioEnum[key] })
        this[`${key}Local`] = croppedFile
        if (croppedFile) {
          this[`${key}Buffer`] = {
            file: croppedFile,
            preview: URL.createObjectURL(croppedFile)
          }
        }
      }
    }
  }
}
</script>

<style module lang="scss">
.actionSidebarDesign {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.actionSidebarDesignItems {
  display: flex;
  gap: 16px;
}
</style>
